import clsx from 'clsx';
import React, { useState } from 'react';

import MenuLink, { MenuLinkTypes } from './MenuLink';
import './styles.scss';

interface ExpandableMenuProps {
  children?: React.ReactNode;
  isPro?: boolean;
  name: string;
  showSeparator?: boolean;
  onClickCapture?: () => void;
}

const ExpandableMenu = ({
  children,
  isPro,
  name,
  onClickCapture,
  showSeparator,
}: ExpandableMenuProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div
      className={clsx({
        'border-0 border-b border-solid border-grayscale-gray pb-2': showSeparator,
      })}
    >
      <MenuLink
        name={name}
        as={MenuLinkTypes.Button}
        isMenuOpen={isMenuOpen}
        onClick={() => setIsMenuOpen((prevMenuOpenState) => !prevMenuOpenState)}
        onClickCapture={onClickCapture}
        isPro={isPro}
        aria-expanded={isMenuOpen}
      />
      <div
        className={clsx('animated-expandable-menu', {
          'is-open': isMenuOpen,
        })}
      >
        <div className="mb-20 min-h-0 overflow-hidden">{children}</div>
      </div>
    </div>
  );
};

export default ExpandableMenu;
